<template>
  <div>
    <main>
      <section>
        <div class="container">
          <div class="row spacer-top">
            <div class="col-lg-4 col-md-4">
              <div class="card m-b-30 bg-default">
                <div class="card-body text-black">
                  <div class="pb-2">
                    <div class="avatar avatar-lg">
                      <router-link :to="{ path: '/view-clients-agency' }">
                        <div
                          class="avatar-title bg-soft-primary rounded-circle"
                        >
                          <i class="fe fe-users"></i>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div>
                    <p class="h4">Basic Healthcare Provision Fund</p>
                    <h1 class="fw-400">
                      {{ informaldata.bhcpf | numeral(0, 0) }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4">
              <div class="card m-b-30 bg-dark">
                <div class="card-body text-white">
                  <div class="pb-2">
                    <div class="avatar avatar-lg">
                      <router-link :to="{ path: '/view-clients-agency' }">
                        <div
                          class="avatar-title bg-soft-primary rounded-circle"
                        >
                          <i class="fe fe-users"></i>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div>
                    <p class="h4">State Equity Program</p>
                    <h1 class="fw-400">
                      {{ informaldata.sep | numeral(0, 0) }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4">
              <div class="card m-b-30 bg-secondary">
                <div class="card-body text-dark">
                  <div class="pb-2">
                    <router-link :to="{ path: '/plans' }">
                      <div class="avatar avatar-lg">
                        <div
                          class="avatar-title bg-soft-primary rounded-circle"
                        >
                          <i class="fe fe-users"></i>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <div>
                    <p class="h4">Voluntary Contributor</p>
                    <h1 class="fw-400">
                      {{ informaldata.voluntary | numeral(0, 0) }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="col-lg-3 col-md-3">
              <div class="card m-b-30 bg-primary">
                <div class="card-body text-dark">
                  <div class="pb-2">
                    <router-link :to="{ path: '/plans' }">
                      <div class="avatar avatar-lg">
                        <div
                          class="avatar-title bg-soft-primary rounded-circle"
                        >
                          <i class="fe fe-users"></i>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <div>
                    <p class="h4 text-white">Dependents</p>
                    <h1 class="fw-400 text-white">
                      0
                    </h1>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="col-lg-3 col-md-3">
              <div class="card m-b-30 bg-light bg-gradient">
                <div class="card-body text-black">
                  <div class="pb-2">
                    <router-link :to="{ path: '/my-providers' }">
                      <div class="avatar avatar-lg">
                        <div
                          class="avatar-title bg-soft-primary rounded-circle"
                        >
                          <i class="fe fe-activity"></i>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <div>
                    <p class="h4">Health Facilities</p>
                    <h1 class="fw-400">{{ informaldata.providers }}</h1>
                    <!-- <h1 class="fw-400">286</h1> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-3">
              <div class="card m-b-30 bg-warning">
                <div class="card-body text-dark">
                  <div class="pb-2">
                    <router-link :to="{ path: '/all-claims' }">
                      <div class="avatar avatar-lg">
                        <div
                          class="avatar-title bg-soft-primary rounded-circle"
                        >
                          <i class="fe fe-credit-card"></i>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <div>
                    <p class="h4">Claims</p>
                    <h1 class="fw-400">
                      {{ informaldata.claims | numeral(0, 0) }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-3">
              <div class="card m-b-30 bg-success">
                <div class="card-body text-dark">
                  <div class="pb-2">
                    <router-link :to="{ path: '/list-records' }">
                      <div class="avatar avatar-lg">
                        <div
                          class="avatar-title bg-soft-primary rounded-circle"
                        >
                          <i class="fe fe-file-plus"></i>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <div>
                    <p class="h4">All Encounters</p>
                    <h1 class="fw-400">
                      {{ informaldata.encounters | numeral(0, 0) }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-3">
              <div class="card m-b-30 bg-info">
                <div class="card-body text-black">
                  <div class="pb-2">
                    <div class="avatar avatar-lg">
                      <router-link :to="{ path: '/view-clients-agency' }">
                        <div
                          class="avatar-title bg-soft-primary rounded-circle"
                        >
                          <i class="fe fe-users"></i>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div>
                    <p class="h4">Total Informal Enrollees</p>
                    <h1 class="fw-400">
                      {{
                        informaldata.bhcpf +
                        informaldata.sep +
                        informaldata.voluntary | numeral(0, 0)
                      }}
                    </h1>
                    <!-- <h1 class="fw-400">286</h1> -->
                  </div>
                </div>
              </div>
            </div>

           
         
          </div>

          <informalLga />

          <div class="row">
            <div class="col-md-12 p-t-20">
              <h5 class="h5">
                <i class="fe fe-activity"></i>Gender Distribution by LGA
              </h5>
            </div>

            <div class="col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <GenderbyLGA :sectors="sectors" />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 p-t-20">
              <h5 class="h5">
                <i class="fe fe-activity"></i>Enrollee Distribution by
                Vulnerable Group
              </h5>
            </div>
            <div class="col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <VulnerableByLGA />
                </div>
              </div>
            </div>
          </div>

         

          <div class="row">
            <!-- <div class="col-md-4">
              <genderCategoryInformal />
            </div> -->

            <div class="col-md-6">
              <ChartAboveAndBelow18 />
            </div>

           
          </div>

          <h5 class="h5">
            <i class="fe fe-activity"></i> Category of Vulnerable Group Data
          </h5>
          <div class="row">
            <div class="col-md-6">
              <BasicCategory />
            </div>
            <div class="col-md-6">
              <genderCategory />
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import InformalLga from "./informallga";
import BasicCategory from "./basicCategory";
import GenderbyLGA from "./GenderbyLGA";
import VulnerableByLGA from "./VulnerableByLGA";
import genderCategory from "./genderCategory";

export default {
  components: {
    GenderbyLGA,
    InformalLga,
    BasicCategory,
    genderCategory,
    VulnerableByLGA,
  },

  data() {
    return {
      user: null,
      agency: "",
      mydata: "",
      informaldata: "",
      auth_user: "",
      providers: "",
      sectors: [
        {
          name: "Basic Healthcare Provision Fund",
        },
        {
          name: "State Equity Program",
        },
      ],
      clients: "",
      total_clients: "",
      offlineclients: [],
      employees: "",
      plans: "",
      tpas: "",
    };
  },
  beforeMount() {

    this.agency = JSON.parse(localStorage.getItem("agency"));
    this.axios
      .get(`/api/v1/auth/getinformalsectorenrollees`)
      .then((response) => {
        this.informaldata = response.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {},

  methods: {},
  created() {},
};
</script>
<style lang="css" scoped>
.spacer-top {
  margin-top: 10px;
}
</style>
